import React, { useState } from "react";
import api from "../../../../../api/axios";

const AddRoomType = ({ onAdded }) => {
  const [roomTypeName, setRoomTypeName] = useState("");

  const handleAddRoomType = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        name: roomTypeName,
        active: true,
      };

      const result = await api.post("/pms/room-type", payload);
      setRoomTypeName("");
      if (onAdded) onAdded();
    } catch (error) {
      console.error("Add facility failed:", error);
    }
  };
  return (
    // <div
    //   className="offcanvas offcanvas-end"
    //   tabIndex="-1"
    //   id="add-room"
    //   aria-labelledby="add-room"
    // >
    //   <div className="offcanvas-header">
    //     <h5 className="offcanvas-title">Add Room Type</h5>
    //     <button
    //       type="button"
    //       className="btn-close"
    //       data-bs-dismiss="offcanvas"
    //       aria-label="Close"
    //     ></button>
    //   </div>
    //   <div className="offcanvas-body">
    //     <form>
    //       <div className="form-group mb-3">
    //         <label className="form-label text-muted">
    //           Room Type <span className="text-danger">*</span>
    //         </label>
    //         <input
    //           type="text"
    //           className="form-control"
    //           placeholder="Add Room Type"
    //         />
    //       </div>
    //       <div className="form-group mb-3">
    //         <label className="form-label text-muted">
    //           Capacity <span className="text-danger">*</span>
    //         </label>
    //         <input
    //           type="number"
    //           className="form-control"
    //           placeholder="Capacity"
    //         />
    //       </div>
    //       <div className="form-group mb-3">
    //         <label className="form-label text-muted">
    //           Extra Capability <span className="text-danger">*</span>
    //         </label>
    //         <input
    //           type="number"
    //           className="form-control"
    //           placeholder="Extra Capability"
    //         />
    //       </div>
    //       <div className="form-group mb-3">
    //         <label className="form-label text-muted">
    //           Room Price <span className="text-danger">*</span>
    //         </label>
    //         <input
    //           type="number"
    //           className="form-control"
    //           placeholder="Room Price"
    //         />
    //       </div>
    //       <div className="form-group mb-3">
    //         <label className="form-label text-muted">
    //           Bed Charge <span className="text-danger">*</span>
    //         </label>
    //         <input
    //           type="number"
    //           className="form-control"
    //           placeholder="Bed Charge"
    //         />
    //       </div>
    //       <div className="form-group mb-3">
    //         <label className="form-label text-muted">
    //           Room Size <span className="text-danger">*</span>
    //         </label>
    //         <select className="form-select">
    //           <option defaultValue="selected">Choose Room Size</option>
    //           <option value="1">Singal</option>
    //           <option value="2">Double</option>
    //           <option value="3">Tripal</option>
    //           <option value="4">Quad</option>
    //           <option value="6">Queen</option>
    //           <option value="7">King</option>
    //           <option value="8">Others</option>
    //         </select>
    //       </div>
    //       <div className="form-group mb-3">
    //         <label className="form-label text-muted">
    //           Bed Number <span className="text-danger">*</span>
    //         </label>
    //         <input
    //           type="number"
    //           className="form-control"
    //           placeholder="Bed Number"
    //         />
    //       </div>
    //       <div className="form-group mb-3">
    //         <label className="form-label text-muted">
    //           Bed Type <span className="text-danger">*</span>
    //         </label>
    //         <select className="form-select">
    //           <option defaultValue="selected">Choose Room Size</option>
    //           <option value="1">King Bed</option>
    //           <option value="2">Queen Bed</option>
    //           <option value="3">Electric Bed</option>
    //           <option value="4">Futon Bed</option>
    //           <option value="6">Mattress Bed</option>
    //           <option value="7">Air Bed</option>
    //         </select>
    //       </div>
    //       <div className="form-group mb-3">
    //         <label className="form-label text-muted">
    //           Room Drescription <span className="text-danger">*</span>
    //         </label>
    //         <textarea className="form-control"></textarea>
    //       </div>
    //       <div className="form-group mb-3">
    //         <label className="form-label text-muted">
    //           Reserve Condition <span className="text-danger">*</span>
    //         </label>
    //         <textarea className="form-control"></textarea>
    //       </div>
    //     </form>
    //     <div className="d-flex">
    //       <button type="button" className="btn w-100 me-1 py-2 btn-primary">
    //         Clear
    //       </button>
    //       <button type="button" className="btn w-100 ms-1 py-2 btn-dark">
    //         Save
    //       </button>
    //     </div>
    //   </div>
    // </div>
    <div
      className="modal fade"
      id="add-room-type"
      tabIndex="-1"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5">Add Room Facilites</h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form onSubmit={handleAddRoomType}>
            <div className="modal-body">
              <div className="form-group">
                <label className="form-label text-muted">Room Type</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Room Type"
                  value={roomTypeName}
                  onChange={(e) => setRoomTypeName(e.target.value)}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="submit" className="btn btn-primary">
                Save changes
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddRoomType;
